
/**
* @ngdoc directive
* @name tc.anchor.directive:a
* @description
* Anchor directive. Handles disabling of links, keydown handler and assigns tabIndex
*/

angular.module('tc.anchor', []).directive('a', function(tcConstants) { //eslint-disable-line
	return {
			restrict: 'E',
			priority: 100,
			compile: function() {
				return {
					pre: function(scope, element, attrs) {
						if ((angular.isUndefined(attrs.href)
							&& angular.isUndefined(attrs.ngHref)
							&& angular.isUndefined(attrs.ngClick))) {
							return;
						}
						
						if (angular.isDefined(attrs.ngDisabled)) {
							// For anchor elements, we have to set tabindex manually when the
							// element is disabled
							if (angular.isUndefined(attrs.tabindex)) {
								scope.$watch(attrs.ngDisabled, function(isDisabled) {
									element.attr('tabindex', isDisabled ? -1 : 0);
								});
							}

							// Disable click event when disabled is true
							// Can't use 'pointer-events: none', as it is not supported by MS Edge
							element.on('click', function(event) {
								if (attrs.disabled === true) {
									event.preventDefault();
									event.stopImmediatePropagation();
									return false;
								}
							});
						}
						
						if (angular.isUndefined(attrs.ngKeydown)) {
							// Attach keydown handler that also checks disabled state
							element.on('keydown', function(event) {
								if ((event.keyCode !== tcConstants.KEY_CODE.ENTER)
									&& (event.keyCode !== tcConstants.KEY_CODE.SPACE)) return;
								
								if (attrs.disabled === true) {
									event.preventDefault();
									event.stopImmediatePropagation();
									return false;
								} else {
									event.preventDefault();
									event.stopImmediatePropagation();
									element[0].click();
								}
							});
						}
					}
				};
			}
		};

});

